import { Injectable } from '@angular/core';
import {ClienteService} from "./cliente.service";
import {NotificacoesService} from "./notificacoes.service";
import {StatusWhatsapp} from "../objetos/StatusWhatsapp";
import {BehaviorSubject} from "rxjs";
import {ArmazenamentoService} from "./armazenamento.service";
import {ResultadoEnvioWhatsapp} from "../../../server/domain/ResultadoEnvioWhatsapp";

class StatusEnvio {
  enviando: boolean;
  horario: Date = new Date();

  enviou() {
    this.enviando = false;
  }

  enviandoMsg() {
    this.enviando = true;
    this.horario = new Date();
  }

  estahEnviando() { //se tempo menor que 10 segundos
    const tempo = new Date().getTime() - this.horario.getTime();

    return this.enviando && tempo < 10000;
  }
}


@Injectable({
  providedIn: 'root'
})
export class WhatsappService {
  statusEnvio = new StatusEnvio();
  mensagens = [];
  mapMensagens: {[id: string]: { id: string | number; status: string; statusSistema?: string }} = {};
  private tentativasEnvio: {[id: string]: number} = {};
  private resultadosEnvio = new ResultadoEnvioWhatsapp();
  private notificacaoAutomaticaEmCurso = false;
  private assinaturaAutomaticaSuprimida = false;
  private enviosEmCurso = new Set<string | number>();
  private notificacoesAutomaticas = new Set<string | number>();
  private notificacoesRevisadas = new Set<string | number>();

  private status = new BehaviorSubject<StatusWhatsapp>(new StatusWhatsapp(false, false, false, null));
  private novaMensagem = new BehaviorSubject<any>({});

  status$ = this.status.asObservable();
  novaMensagem$ = this.novaMensagem.asObservable();

  constructor(private clienteService: ClienteService, private notificacoesService: NotificacoesService,
              private armazenamentoService: ArmazenamentoService) { }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public envieMensagemNoWhatsapp(msg: any) {
    console.log('envieMensagem', msg);

    const registroExistente = this.mapMensagens[msg.id];
    const veioDaFila = msg && msg._origemFila === true;
    if( veioDaFila ) {
      delete msg._origemFila;
    }

    if( this.notificacaoAutomaticaEmCurso || this.assinaturaAutomaticaSuprimida || this.statusEnvio.estahEnviando() ) {
      console.log('\t\tdescartando mensagens');

      if( !registroExistente ) {
        msg._origemFila = true;
        this.mapMensagens[msg.id] = { id: msg.id, status: 'RECEBIDA', statusSistema: 'FILA' };
        this.mensagens.push(msg);
      } else {
        console.log('[WhatsappService] Mensagem duplicada ignorada:', msg.id);
      }

      return;
    }

    if( registroExistente && !veioDaFila ) {
      console.log('[WhatsappService] Mensagem duplicada ignorada:', msg.id);
      return;
    }

    this.mapMensagens[msg.id] = { id: msg.id, status: 'RECEBIDA', statusSistema: 'ENVIANDO' };
    this.enviosEmCurso.add(msg.id);

    this.obtenha(msg.id).then( (msgObtida: any) => {
      if( msgObtida && msgObtida.status === 'ENVIADA' ) {
        this.enviosEmCurso.delete(msg.id);
        return this.pegueProximaMensagem({
          sucesso: true,
          idMensagem: msg.id,
          msg: msg
        }, 0);
      }

      if( msgObtida && msgObtida.status === 'ENVIANDO' ) {
        console.log('[WhatsappService] mensagem já está ENVIANDO, ignorando', msg.id);
        return;
      }

      msg.status = 'ENVIANDO';

      return this.salveMensagem(msg).then( () => {
        this.notifiqueIframeEnviarMsg(msg);
      });
    }).catch((erro: any) => {
      this.enviosEmCurso.delete(msg.id);
      console.error('[WhatsappService] Erro antes do envio:', erro);
    });
  }

  public envieMensagemNoWhatsappComResultado(msg: any): Promise<any> {
    const resultado = this.resultadosEnvio.aguarde(msg && msg.id);
    this.envieMensagemNoWhatsapp(msg);
    return resultado;
  }

  public podeEnviarNotificacaoAutomatica(): boolean {
    return !this.notificacaoAutomaticaEmCurso && !this.assinaturaAutomaticaSuprimida && !this.statusEnvio.estahEnviando() &&
      this.enviosEmCurso.size === 0 && this.mensagens.length === 0;
  }

  public restaureAssinaturaPessoal(usuario: any) {
    if (!this.notificacaoAutomaticaEmCurso) {
      this.salveAssinaturaNaExtensao(usuario?.assinarMensagens ? usuario.nome : '');
      this.assinaturaAutomaticaSuprimida = false;
    }
  }

  private salveAssinaturaNaExtensao(assinatura: string) {
    window.parent.postMessage({tipo: 'NOVA_MENSAGEM', text: {
      tipo: 'SALVAR_ASSINATURA', assinatura: assinatura || ''
    }}, '*');
  }

  public async envieNotificacaoSemAssinatura(msg: any, obtenhaUsuario: () => any): Promise<any> {
    if (this.mapMensagens[msg.id]?.status === 'ENVIADA') {
      return {idMensagem: msg.id, msg, sucesso: true, status: 'ENVIADA'};
    }
    if (!this.podeEnviarNotificacaoAutomatica()) {
      throw new Error('Existe outro envio de WhatsApp ativo ou na fila.');
    }

    this.notificacaoAutomaticaEmCurso = true;
    let despachou = false;
    try {
      msg.status = 'ENVIANDO';
      await this.salveMensagem(msg);
      const resultado = this.resultadosEnvio.aguarde(msg.id);
      this.notificacoesAutomaticas.add(msg.id);
      this.enviosEmCurso.add(msg.id);
      try {
        this.assinaturaAutomaticaSuprimida = true;
        this.salveAssinaturaNaExtensao('');
        this.notifiqueIframeEnviarMsg(msg);
        despachou = true;
      } catch (erro) {
        this.notificacoesAutomaticas.delete(msg.id);
        this.enviosEmCurso.delete(msg.id);
        this.statusEnvio.enviou();
        this.resultadosEnvio.conclua(msg.id, {sucesso: false, status: 'ERRO_ENVIO'});
        throw erro;
      }
      return await resultado;
    } catch (erro) {
      if (despachou) erro.incerto = true;
      throw erro;
    } finally {
      const usuario = obtenhaUsuario();
      try {
        this.salveAssinaturaNaExtensao(usuario?.assinarMensagens ? usuario.nome : '');
        this.assinaturaAutomaticaSuprimida = false;
      } catch (erro) {
        if (despachou) erro.incerto = true;
        throw erro;
      } finally {
        this.notificacaoAutomaticaEmCurso = false;
      }
      // Um timeout não cancela o envio na extensão. Aguarde sua resposta tardia
      // antes de iniciar outra notificação automática com resultado desconhecido.
      if (this.enviosEmCurso.size === 0 && this.mensagens.length > 0) {
        await this.pegueProximaMensagem({msg}, 0);
      }
    }
  }

  public enviouMensagem(respostaEnvio: any) {
    // Uma tentativa revisada pode responder muito depois do timeout. Nunca
    // permita que caia no retry comum nem altere a assinatura de outra geração.
    if (this.notificacoesRevisadas.has(respostaEnvio?.idMensagem)) return Promise.resolve();
    if (this.notificacoesAutomaticas.has(respostaEnvio?.idMensagem)) {
      return this.concluaNotificacaoAutomatica(respostaEnvio);
    }
    // Após reabrir o painel, o callback pode pertencer à instância anterior.
    // Cobranças sem tentativa local conhecida nunca entram no retry legado.
    if (/^fatura-cobranca-\d+-\d+(?:-\d+)?$/.test(String(respostaEnvio?.idMensagem))) return Promise.resolve();
    this.enviosEmCurso.delete(respostaEnvio?.idMensagem);
    return new Promise<void>( (resolve, reject) => {
      console.log('enviou Mensagem', respostaEnvio);

      //this.enviando = false;
      this.statusEnvio.enviou();
      this.novaMensagem.next(respostaEnvio.msg);

      let delay = 0;

      let status = 'NOVA';
      const statusEnvio = respostaEnvio?.status;
      const idMensagem = respostaEnvio?.idMensagem;
      const naoRegistrarServidor = respostaEnvio?.msg?.naoRegistrarServidor === true;
      const statusParaRetentar = ['NAO_PRONTO', 'ERRO_CONTATO', 'ERRO_ENVIO', 'ERRO_PREPARACAO', 'ERRO_GERAL'];

      if( idMensagem && statusParaRetentar.indexOf(statusEnvio) !== -1 ) {
        const tentativas = (this.tentativasEnvio[idMensagem] || 0) + 1;
        this.tentativasEnvio[idMensagem] = tentativas;

        if( tentativas < 3 ) {
          if( !naoRegistrarServidor ) {
            this.notifiqueServidorQueEnviouMensagens(idMensagem, statusEnvio, respostaEnvio.idw, false);
          }
          respostaEnvio.msg._origemFila = true;
          this.mensagens.unshift(respostaEnvio.msg);
          delay = 2000;
          status = 'NOVA';
        } else {
          delete this.tentativasEnvio[idMensagem];
          status = 'IMPOSSIVEL_ENVIAR';
          if( !naoRegistrarServidor ) {
            this.notifiqueServidorQueEnviouMensagens(idMensagem, status, respostaEnvio.idw, false);
          }
        }
      } else if( respostaEnvio ) {
        if( idMensagem ) delete this.tentativasEnvio[idMensagem];
        status = respostaEnvio.status;
        if( !naoRegistrarServidor ) {
          this.notifiqueServidorQueEnviouMensagens(respostaEnvio.idMensagem, respostaEnvio.status, respostaEnvio.idw,
            respostaEnvio.sucesso);
        }
      }

      const msg = respostaEnvio.msg;

      msg.status = status;

      if( idMensagem && status !== 'NOVA' ) {
        this.resultadosEnvio.conclua(idMensagem, Object.assign({}, respostaEnvio, {
          status,
          sucesso: respostaEnvio.sucesso === true && status === 'ENVIADA'
        }));
      }

      this.salveMensagem(msg).then( async () => {
        resolve();

        console.log('qtde mensagens: ' + this.mensagens.length);

        await this.pegueProximaMensagem(respostaEnvio, delay);
      });
    });
  }

  public async libereNotificacaoRevisada(id: string): Promise<boolean> {
    if (this.notificacaoAutomaticaEmCurso || this.assinaturaAutomaticaSuprimida ||
        (!this.notificacoesAutomaticas.has(id) && !this.mapMensagens[id]) ||
        Array.from(this.enviosEmCurso).some(atual => atual !== id)) return false;
    this.notificacoesRevisadas.add(id);
    this.notificacoesAutomaticas.delete(id);
    this.enviosEmCurso.delete(id);
    this.statusEnvio.enviou();
    if (this.mensagens.length > 0) await this.pegueProximaMensagem({msg: {id, naoRegistrarServidor: true}}, 0);
    return true;
  }

  private async concluaNotificacaoAutomatica(resposta: any): Promise<void> {
    const falhou = resposta.sucesso !== true || resposta.status !== 'ENVIADA';
    // Tickets mantêm a recuperação pela fila do servidor. Cobranças exigem revisão.
    const ticket = /^suporte-sistema-\d+$/.test(String(resposta.idMensagem));
    const incerto = falhou && !ticket;
    this.statusEnvio.enviou();
    this.novaMensagem.next(resposta.msg);
    resposta.msg.status = incerto ? 'INCERTA' : resposta.status;
    await this.salveMensagem(resposta.msg);
    if (this.notificacoesRevisadas.has(resposta.idMensagem)) return;
    if (!incerto) {
      this.enviosEmCurso.delete(resposta.idMensagem);
      // Um callback tardio de ticket com falha também não inicia retry na fila comum.
      if (!falhou) this.notificacoesAutomaticas.delete(resposta.idMensagem);
    }
    this.resultadosEnvio.conclua(resposta.idMensagem, Object.assign({}, resposta, incerto ? {incerto: true} : {}, {
      sucesso: resposta.sucesso === true && resposta.status === 'ENVIADA'
    }));
    if (!this.notificacaoAutomaticaEmCurso && this.enviosEmCurso.size === 0 && this.mensagens.length > 0) {
      await this.pegueProximaMensagem(resposta, 0);
    }
  }

  public async pegueProximaMensagem(respostaEnvio: any, delay: number) {
    if (this.notificacaoAutomaticaEmCurso || this.assinaturaAutomaticaSuprimida) return;
    if( this.mensagens.length > 0 ) {
      await this.sleep(delay);
      if (this.notificacaoAutomaticaEmCurso || this.assinaturaAutomaticaSuprimida || this.mensagens.length === 0) return;

      const novaMensagem = this.mensagens.shift();

      console.log('pegando próxima da fila', novaMensagem);

      this.envieMensagemNoWhatsapp(novaMensagem);
    } else { //fila está vazia
      console.log('obtendo proxima do server');

      this.obtenhaProximaMensagemNoServidor(respostaEnvio, respostaEnvio.msg);
    }
  }

  public obtenhaProximaMensagemNoServidor(respostaEnvio: any, msg: any) {
    if( !msg.id || msg.naoRegistrarServidor ) {
      return;
    }

    let tempo = 0;
    if( respostaEnvio.msg.tipoDeNotificacao === 'Marketing' ) {
      tempo = Math.floor(Math.random() * 3000) + 1000;
    }

    let idMensagem = msg.id;

    if( !respostaEnvio.sucesso ) {
      idMensagem = parseInt(this.armazenamentoService.carregue('idm2', false), 10);
    }

    setTimeout(() => {
      this.clienteService.proximaMensagem(idMensagem).then( () => {});
    }, tempo);
  }

  private async aviseEnvieiMensagens(idMensagem: string, status: string, idWhatsapp: string, sucesso: boolean = false) {
    return this.clienteService.envieiMensagem(idMensagem, status, idWhatsapp, sucesso);
  }

  private async notifiqueServidorQueEnviouMensagens(idMensagem: string, status: string, idWhatsapp: string,
                                                    sucesso: boolean = false) {
    if( !idMensagem ) {
      return;
    }

    let resposta = null;

    try {
      resposta = await this.aviseEnvieiMensagens(idMensagem, status, idWhatsapp, sucesso);
    } catch( erro ) {
      console.log('Erro ao tentar notificar servidor');
      console.log(erro);

      if (!resposta) {
        setTimeout(() => {
          this.notifiqueServidorQueEnviouMensagens(idMensagem, status, idWhatsapp);
        }, 3000);
      }
    }
  }

  obtenha(idMensagem: number) {
    return new Promise( (resolve, reject) => {
      if( !idMensagem ) {
        return resolve(null);
      }

      const msg = this.mapMensagens[idMensagem];

      resolve(msg);
    });
  }

  salveMensagem(mensagem: any) {
    return new Promise<void>( (resolve, reject) => {
      if( !mensagem.id ) {
        return resolve();
      }

      const objeto = {
        id: mensagem.id,
        status: mensagem.status
      };

      if (mensagem.status === 'ENVIADA' && !mensagem.naoRegistrarServidor) {
        const idMensagemNumero = parseInt(this.armazenamentoService.carregue('idm2', false), 10);

        console.log('[WhatsappService] id: ' + mensagem.id + " -> " + idMensagemNumero);

        this.armazenamentoService.salveSemExpirar('idm2', mensagem.id);
      }

      const existente = this.mapMensagens[mensagem.id];
      let statusSistema = existente?.statusSistema;

      if( mensagem.status === 'NOVA' ) {
        statusSistema = 'REENVIO';
      } else if( mensagem.status === 'ENVIANDO' ) {
        statusSistema = 'ENVIANDO';
      } else if( mensagem.status === 'ENVIADA' || mensagem.status === 'IMPOSSIVEL_ENVIAR' ) {
        statusSistema = 'FINALIZADA';
      }

      this.mapMensagens[mensagem.id] = {
        ...(existente || {}),
        ...objeto,
        statusSistema: statusSistema
      };
      resolve();
    });
  }

  public notifiqueIframeEnviarMsg(msg: any) {
    this.statusEnvio.enviandoMsg();

    if( msg.imagem ) {
      this.toDataUrl(this.obtenhaUrlServidor() + msg.imagem, (dados: any) => {
        msg.dadosImagem = dados;
        window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: msg}, "*");
      });
    } else {
      window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: msg}, "*");
    }
  }

  private toDataUrl(url, callback) {
    console.log('baixando imagem: ' + url);

    const xhr = new XMLHttpRequest();
    xhr.onload = function() {
      const reader = new FileReader();
      reader.onloadend = function() {
        callback(reader.result);
      }
      reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
  }

  public obtenhaUrlServidor() {
    return window.location.protocol + '//' + window.location.hostname +
      (window.location.port ?  ':' + window.location.port : '');
  }


  obtenhaRespostaMensagemLista(empresa: any, contato: any, opcao: any): Promise<any> {
    return this.notificacoesService.obtenhaRespostaMensagemLista(empresa, contato, opcao);
  }

  processeMensagemSaudacao(empresa: any, contato: any): Promise<any> {
    return this.notificacoesService.obtenhaMensagemSaudade(contato);
  }

  processeMensagemLinkPagamento(guid: string): Promise<any> {
    return this.notificacoesService.obtenhaMensagemLinkPagamento(guid);
  }

  processeMensagemCodigoValidacao(empresa: any, contato: any): Promise<any> {
    return this.notificacoesService.obtenhaMensagemCodigoValidacao(contato);
  }

  monitoreStatusIntegracao() {
    console.log('[Whatsapp.Service] checando se status whtasapp:');

    window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {tipo: 'STATUS_WHATSAPP'}}, "*");

    setTimeout(() => {
      this.monitoreStatusIntegracao();
    }, 10000);
  }

  mudeStatus(data: StatusWhatsapp) {
    this.status.next(data);
  }

  marqueDigitando(telefone: string) {
    window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {
        tipo: 'DIGITANDO',
        telefone: telefone
      }}, "*");
  }

  notifiqueMensagensAntigas() {
    window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {
        tipo: 'NOTIFIQUE_MENSAGENS_ANTIGAS'
      }}, "*");
  }

  abraConversa(telefone) {
    window.parent.postMessage({tipo: "NOVA_MENSAGEM", text: {
        tipo: 'ABRA_CHAT',
        telefone: telefone
      }}, "*");
  }
}
